function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.51 294.44C32.9023 287.966 27.7563 281.106 23.1101 273.91L121.39 175.64L23.1101 77.36C27.7588 70.1694 32.9047 63.3127 38.51 56.84L157.31 175.64L38.51 294.44ZM10.1901 101.09C6.33424 109.631 3.15448 118.461 0.680054 127.5L48.8201 175.64L0.680054 223.78C3.15612 232.818 6.33584 241.648 10.1901 250.19L84.7401 175.64L10.1901 101.09ZM175.64 194L56.84 312.8C63.3064 318.413 70.1637 323.559 77.3601 328.2L175.64 229.92L273.91 328.2C281.106 323.559 287.964 318.413 294.43 312.8L175.64 194ZM250.19 341.13L175.63 266.57L101.08 341.12C109.622 344.973 118.453 348.152 127.49 350.63L175.63 302.49L223.78 350.63C232.817 348.138 241.647 344.949 250.19 341.09V341.13ZM175.64 157.31L294.43 38.51C287.961 32.9032 281.104 27.7604 273.91 23.12L175.64 121.39L77.3601 23.12C70.1662 27.7604 63.3091 32.9032 56.84 38.51L175.64 157.31ZM341.08 250.19C344.936 241.649 348.116 232.818 350.59 223.78L302.45 175.64L350.59 127.5C348.114 118.459 344.934 109.625 341.08 101.08L266.53 175.64L341.08 250.19ZM229.88 175.64L328.16 77.36C323.514 70.1677 318.368 63.3108 312.76 56.84L194 175.64L312.8 294.44C318.408 287.966 323.554 281.106 328.2 273.91L229.88 175.64ZM175.63 84.74L250.19 10.19C241.648 6.33736 232.818 3.1577 223.78 0.679993L175.63 48.82L127.49 0.679993C118.454 3.16214 109.624 6.34168 101.08 10.19L175.63 84.74Z",
  fill: "url(#paint0_radial_589_940)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_589_940",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(381.44 351.37) scale(515.14)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})));

function SvgAlexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 351 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexLogo);
export default __webpack_public_path__ + "static/media/alexLogo.296cf93cf8dfe5d933ab56cfe21ed1d2.svg";
export { ForwardRef as ReactComponent };